import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import { toast } from 'react-toastify'

import WhiteFooter from 'components/Footers/WhiteFooter.js'
import logoMural from 'assets/img/logo_mural_2.png'
import { StudentService } from 'services/student'
import File from 'components/Inputs/File'
import Loading from 'components/Loading/Loading'
import { StudentsHelper } from 'helpers/students'
import useUnsavedChangesWarning from 'hooks/useUnsavedChangesWarning'
import PanelContext from 'contexts/Panel'
import * as XLSX from 'xlsx'
import StudentsTable2 from 'components/Table/StudentsTable2'
import $RDStation from 'services/rdstation'
import AuthContext from 'contexts/Auth'

const defaultFile = { preview: '', raw: '' }

const PesquisaMassaPage = ({ history }) => {
  const { user } = useContext(AuthContext)
  const { year, semester, setYear, setSemester, years } = useContext(PanelContext)

  const [largeModal, setLargeModal] = useState(false)
  const [studentsList, setStudentsList] = useState([])
  const [isStudentsListVisible, setIsStudentListVisible] = useState(false)
  const [isModalLoading, setIsModalLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [clean, setClean] = useState(false)
  const [file, setFile] = useState(defaultFile)

  const { Prompt, setDirty } = useUnsavedChangesWarning('Tem certeza que deseja sair? Seus dados podem não ter sido salvos.')

  const goBack = () => {
    history.push('/mural-aprovados-sisu')
  }

  const handledownloadExampleSheet = async () => await StudentService.downloadExampleSheet()

  const sendStudentList = useCallback(async () => {
    try {
      setIsModalLoading(true)

      const data = studentsList.map((student) => {
        if (student.Id <= 0) {
          return {
            IdAprovado: null,
            NomeDoAlunoNaoEncontrado: student.NomeInscrito,
          }
        }

        return {
          IdAprovado: student.Id,
          NomeDoAlunoNaoEncontrado: null,
        }
      })

      const response = await StudentService.sendStudents(data)

      if (response.status === 200) {
        toast.success('Lista de aprovados enviada com sucesso!')
        setStudentsList([])
        setIsStudentListVisible(false)
        return true
      }
    } catch (e) {
      toast.error('Houve um erro inesperado')
    } finally {
      setIsModalLoading(false)
    }
  }, [studentsList])

  const handleExit = useCallback(async () => {
    const saved = await sendStudentList()
    if (saved) history.push('/mural-aprovados-sisu')
  }, [history, sendStudentList])

  const handleOnInputChange = useCallback((file) => {
    setClean(false)
    setFile(file)
  }, [])

  const handleUpload = useCallback(async (e) => {
    e.preventDefault()

    setIsLoading(true)

    const reader = new FileReader()

    reader.onload = async (e) => {
      const workbook = XLSX.read(e.target.result, {
        type: 'binary'
      })

      const first_sheet_name = workbook.SheetNames[0]

      const worksheet = workbook.Sheets[first_sheet_name]

      const rows = XLSX.utils.sheet_to_json(worksheet, {
        header: 1
      })

      if (rows[0][0] === 'nome')
        rows.shift()

      if (rows.length > 5000) {
        toast.error('A planilha excedeu o limite de 5000 nomes.')
        return
      }

      const names = []

      rows.forEach(columns => {
        if (columns.length > 0 && typeof columns[0] === 'string') {
          const name = columns[0].trim()

          if (name.length > 0) {
            names.push(name)
          }
        }
      })

      try {
        await $RDStation.conversation('consulta_mural_sisu', {
          company_name: user.NomeEscola,
          name: user.Nome,
          email: user.Email,
          city: user.Cidade,
          state: user.Estado,
          mobile_phone: user.Celular,
        })
      } finally {}

      try {
        const response = await StudentService.uploadSheet(names, year, semester)

        if (response.status === 200) {
          const data = StudentsHelper.formatList(response.data)
          toast.success('Planilha enviada com sucesso!')
          setStudentsList(data)
          setIsStudentListVisible(true)
        }
      } catch (e) {
        toast.error('Ocorreu um erro ao enviar a planilha, tente novamente.')
        toast.error(e.message)
      } finally {
        setFile(defaultFile)
        setClean(true)
        setIsLoading(false)
      }
    }

    reader.onerror = () => {
      toast.error('Ocorreu um erro ao enviar a planilha, tente novamente.')
      setIsLoading(false)
    }

    reader.readAsBinaryString(file.raw)
  }, [user, file, year, semester])

  useEffect(() => {
    if (file?.raw || studentsList.length > 0) {
      setDirty(true)
    } else {
      setDirty(false)
    }
  }, [file, setDirty, studentsList.length])

  const handleYearChange = ({ target: { value } }) => {
    const [ year, semester ] = value.split('.')
    setYear(parseInt(year))
    setSemester(parseInt(semester))
  }

  const handleDeleteStudent = async (index, { Id }) => {
    setStudentsList(prev => {
      const result = [...prev]
      result.splice(index, 1)
      return result
    })

    StudentService.deleteById(Id)
  }

  return (
    <div className="section">
      {Prompt}

      <Modal
        isOpen={largeModal}
        className="modal-lg"
        modalClassName="bd-example-modal-lg"
        toggle={() => setLargeModal(false)}
      >
        <div style={{ padding: 20 }}>
          <p
            style={{
              fontSize: 24,
              textAlign: 'center',
              fontWeight: 600,
              color: '#000',
            }}
          >
            Deseja enviar para sua lista de aprovados?
          </p>
          <p
            style={{
              fontSize: 14,
              letterSpacing: 2,
              marginBottom: 20,
              textAlign: 'center',
              fontWeight: 400,
              color: '#000',
            }}
          >
            Clicando em sim, suas consultas serão armazenadas
            <br /> em sua lista de aprovados SiSU.
          </p>
          <p>
            <Button
              className="btn-round"
              color="dark"
              onClick={handleExit}
              style={{
                paddingTop: 10,
                paddingBottom: 5,
                fontSize: 14,
                letterSpacing: 4,
                textTransform: 'none',
                color: '#FFF',
                border: 0,
                width: '100%',
                height: 45,
                borderRadius: 20,
              }}
            >
              Sim
            </Button>
          </p>

          <p style={{ marginTop: 10 }}>
            <Button
              className="btn-round mr-1"
              color="neutral"
              onClick={goBack}
              style={{
                paddingTop: 10,
                paddingBottom: 5,
                fontSize: 14,
                letterSpacing: 4,
                textTransform: 'none',
                color: '#000',
                borderColor: '#000',
                width: '100%',
                height: 45,
                borderRadius: 20,
              }}
            >
              Não
            </Button>
          </p>
        </div>
      </Modal>

      <Container className="text-center">
        <Row>
          <Col className="d-flex justify-content-between align-items-center">
            <select
              id="select-year"
              className="form-select"
              aria-label="Selecione o ano"
              onChange={handleYearChange}
              defaultValue={`${year}.${semester}`}
              style={{
                color: '#000',
                borderColor: '#aaa',
              }}
            >
              {years.map(item => (
                <option value={item.value} key={item.value}>{item.label}</option>
              ))}
            </select>

            <Button
              onClick={() => (studentsList?.length ? setLargeModal(true) : goBack())}
              className="btn-round"
              color="#000"
            >
              <span>X</span>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <img src={logoMural} style={{ width: 260 }} alt="" />
          </Col>
        </Row>
      </Container>

      <Container className="text-center">
        <h2
          className="title"
          style={{
            fontWeight: 600,
            letterSpacing: 2,
            marginTop: 30,
            fontSize: 32,
          }}
        >
          Pesquisa em massa
        </h2>
        <br />
        <p
          className="description"
          style={{
            letterSpacing: 2,
            color: '#000',
            marginTop: -20,
            lineHeight: 1.6,
          }}
        >
          Para consultar todas as aprovações da sua escola, preencha a planilha de excel, disponibilizada no 1º passo, com o nome completo de <span style={{fontWeight:600}}>até 5000 estudantes por planilha.</span> Selecione a planilha preenchida <br />(2º passo) e a envie para conferir seus resultados (3º passo).
        </p>
      </Container>
      <Container className="text-center" style={{ marginTop: 30 }}>
        <Row>
          <Col>
            <div>
              <p
                style={{
                  fontWeight: 600,
                  color: '#E94B4B',
                  fontSize: 18,
                  letterSpacing: 3,
                  marginBottom: 20,
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
              >
                1º Passo
              </p>
              <p
                style={{
                  fontWeight: 600,
                  color: '#E94B4B',
                  fontSize: 18,
                  letterSpacing: 3,
                  marginBottom: 20,
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
              >
                <i className="nc-icon nc-paper" style={{ color: '#000' }} />
              </p>

              <p
                style={{
                  fontWeight: 400,
                  color: '#000',
                  fontSize: 14,
                  letterSpacing: 2,
                  marginBottom: 20,
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
              >
                Baixe a planilha
                <br /> de exemplo.
              </p>
              <p>
                <Button
                  onClick={handledownloadExampleSheet}
                  type="button"
                  color="danger"
                  style={{
                    color: '#FFF',
                    letterSpacing: 2,
                    borderRadius: 20,
                    fontWeight: 400,
                    borderWidth: 0,
                    textTransform: 'none',
                    fontSize: 12,
                    lineHeight: 1.5,
                    paddingTop: 20,
                    paddingBottom: 20,
                    paddingRight: 55,
                    paddingLeft: 55,
                  }}
                >
                  <strong>Baixar</strong> planilha
                </Button>
              </p>
            </div>
          </Col>
          <Col>
            <div>
              <p
                style={{
                  fontWeight: 400,
                  color: '#000',
                  fontSize: 18,
                  letterSpacing: 3,
                  marginBottom: 20,
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
              >
                2º Passo
              </p>
              <p
                style={{
                  fontWeight: 600,
                  color: '#E94B4B',
                  fontSize: 18,
                  letterSpacing: 3,
                  marginBottom: 20,
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
              >
                <i className="nc-icon nc-paper" style={{ color: '#000' }} />
              </p>

              <p
                style={{
                  fontWeight: 400,
                  color: '#000',
                  fontSize: 14,
                  letterSpacing: 2,
                  marginBottom: 20,
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
              >
                Selecione a planilha <br />preenchida <span style={{fontWeight:600}}>(até 5000 nomes)</span>
              </p>
              <p>
                <File clean={clean} isLoading={isLoading} onFileChange={handleOnInputChange} />
              </p>
            </div>
          </Col>

          <Col>
            <div>
              <p
                style={{
                  fontWeight: 400,
                  color: '#000',
                  fontSize: 18,
                  letterSpacing: 3,
                  marginBottom: 20,
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
              >
                3º Passo
              </p>
              <p
                style={{
                  fontWeight: 600,
                  color: '#E94B4B',
                  fontSize: 18,
                  letterSpacing: 3,
                  marginBottom: 20,
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
              >
                <i className="nc-icon nc-paper" style={{ color: '#000' }} />
              </p>

              <p
                style={{
                  fontWeight: 400,
                  color: '#000',
                  fontSize: 14,
                  letterSpacing: 2,
                  marginBottom: 20,
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
              >
                Envie sua planilha
                <br />e veja o resultado
              </p>
              <p>
                <Button
                  onClick={handleUpload}
                  type="button"
                  disabled={!file?.raw || isLoading}
                  style={{
                    color: '#000',
                    letterSpacing: 2,
                    borderRadius: 20,
                    fontWeight: 400,
                    borderWidth: 0,
                    textTransform: 'none',
                    fontSize: 12,
                    lineHeight: 1.5,
                    backgroundColor: '#7BCB92',
                    paddingTop: 20,
                    paddingBottom: 20,
                    paddingRight: 55,
                    paddingLeft: 55,
                  }}
                >
                  {isLoading ? (
                    'Aguarde...'
                  ) : (
                    <span>
                      <strong>Enviar</strong> Planilha
                    </span>
                  )}
                </Button>
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      {isStudentsListVisible && (
        <Fragment>
          <Container className="text-center" style={{ marginTop: 40 }}>
            {isModalLoading ? (
              <Loading />
            ) : (
              <Row md={{ size: 12 }} style={{ marginBottom: 20 }}>
                <Col md={{ size: 8 }} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    onClick={sendStudentList}
                    type="button"
                    style={{
                      color: '#FFF',
                      letterSpacing: 3,
                      borderRadius: 15,
                      backgroundColor: '#16057C',
                      borderWidth: 0,
                      textTransform: 'none',
                      fontSize: 14,
                      lineHeight: 1.5,
                      padding: '5px 15px',
                    }}
                  >
                    Enviar para lista de aprovados
                  </Button>
                </Col>
                <Col md={{ size: 4 }} style={{ display: 'flex', justifyContent: 'center' }}>
                  <p
                    className="description"
                    style={{ letterSpacing: 1, color: '#000', lineHeight: 1.6, fontWeight: 600 }}
                  >
                    Total de estudantes <span style={{ fontSize: 22 }}>{studentsList?.length || 0}</span>
                  </p>
                </Col>
              </Row>
            )}

            <div style={{ marginTop: 10, marginBottom: 30 }}>
              <StudentsTable2
                students={studentsList}
                onDelete={handleDeleteStudent}
              />
            </div>
          </Container>
        </Fragment>
      )}

      <WhiteFooter />
    </div>
  )
}

export default PesquisaMassaPage
